import { PhotosUnlinkedFromAssetEvent } from '../event/photos-unlinked-from-asset.event';
const photosUnlinkedFromAssetProjections = {
    [PhotosUnlinkedFromAssetEvent.name]: (event, state) => ({
        ...state,
    }),
};
export default photosUnlinkedFromAssetProjections;
//# sourceMappingURL=photos-unlinked-from-asset.projection.js.map